import { Injectable } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';

@Injectable()
export class FiErrorMessageSharedService {
    readonly defaultErrorMessageCode = 'error_message.default_error';
    readonly defaultHeaderTextId = 'error_message.default_header';
    readonly defaultBackendErrorMessage = 'Something went wrong';

    constructor(private appTextService: AppTextService) {}

    getErrorMessageData(description: { MessageText?: string; HeaderText?: string }) {
        let messageText = description?.MessageText;
        if (!messageText || messageText === this.defaultBackendErrorMessage) {
            messageText = this.appTextService.get(this.defaultErrorMessageCode);
        }
        let headerText = description?.HeaderText;
        if (!headerText) {
            headerText = this.appTextService.get(this.defaultHeaderTextId);
        }
        return {
            messageText: messageText,
            headerText: headerText,
            isDefaultMessage:
                messageText === this.appTextService.get(this.defaultErrorMessageCode) &&
                headerText === this.appTextService.get(this.defaultHeaderTextId),
        };
    }
}
